export interface Review {
  id: string;
  productId: string | number;
  author: string;
  avatar: string;
  rating: number;
  date: string;
  title: string;
  body: string;
  verified: boolean;
  helpful: number;
}

export const mockReviews: Review[] = [
  // 약손콩이 200mlX2병 (id: 1)
  {
    id: 'r1-1',
    productId: 1,
    author: '김정숙',
    avatar: '김',
    rating: 5,
    date: '2025-11-12',
    title: '부모님이 너무 좋아하세요!',
    body: '어버이날 선물로 구매했는데 부모님이 정말 좋아하십니다. 소화도 잘 되고 고소한 맛이 일품이라고 하시네요. 벌써 재구매 부탁을 받았어요. 포장도 깔끔하고 배송도 빨라서 만족합니다.',
    verified: true,
    helpful: 42,
  },
  {
    id: 'r1-2',
    productId: 1,
    author: '박성민',
    avatar: '박',
    rating: 5,
    date: '2025-10-28',
    title: '꾸준히 먹으니 컨디션이 달라져요',
    body: '2개월째 꾸준히 먹고 있는데 피로감이 눈에 띄게 줄었습니다. 직장인인데 퇴근 후 피곤함이 덜해진 느낌이에요. 2병 세트라 가격도 합리적이고 좋습니다.',
    verified: true,
    helpful: 35,
  },
  {
    id: 'r1-3',
    productId: 1,
    author: '이혜원',
    avatar: '이',
    rating: 4,
    date: '2025-10-05',
    title: '맛도 좋고 건강에도 좋아요',
    body: '캡슐 형태가 아닌 환 형태라서 처음엔 낯설었는데 금방 적응했어요. 고소한 맛이 있어서 먹기 거북하지 않아요. 다음엔 5병 세트 구매해볼 생각입니다.',
    verified: true,
    helpful: 18,
  },
  {
    id: 'r1-4',
    productId: 1,
    author: '최재호',
    avatar: '최',
    rating: 5,
    date: '2025-09-18',
    title: '가족 건강을 위한 최고의 선택',
    body: '온 가족이 함께 먹고 있어요. 아이들도 군것질처럼 잘 먹어서 정말 다행입니다. 국내산 원료를 사용한다는 점도 믿음직스러워요.',
    verified: false,
    helpful: 27,
  },
  {
    id: 'r1-5',
    productId: 1,
    author: '강미나',
    avatar: '강',
    rating: 4,
    date: '2025-09-02',
    title: '배송 빠르고 품질 좋아요',
    body: '주문 다음날 바로 도착했어요. 포장이 꼼꼼하게 되어 있어서 제품이 안전하게 왔습니다. 맛은 고소하고 부드러워요. 만족합니다.',
    verified: true,
    helpful: 11,
  },

  // 약손콩이 200mlX5병 (id: 2)
  {
    id: 'r2-1',
    productId: 2,
    author: '윤서준',
    avatar: '윤',
    rating: 5,
    date: '2025-11-20',
    title: '가성비 최고의 선택!',
    body: '2병보다 5병이 훨씬 경제적이에요. 1년치 정도 되는 양이라 한번에 사놓으니 신경 쓸 일이 없어서 좋아요. 온 가족이 매일 먹고 있습니다. 건강 관리하기 딱 좋은 제품이에요.',
    verified: true,
    helpful: 58,
  },
  {
    id: 'r2-2',
    productId: 2,
    author: '오지현',
    avatar: '오',
    rating: 5,
    date: '2025-11-08',
    title: '단골 제품이 됐어요',
    body: '처음엔 2병부터 시작했다가 이제는 항상 5병 세트로 주문해요. 가격 대비 품질이 너무 좋고, 오래 두고 먹어도 품질이 변하지 않는 것 같아요.',
    verified: true,
    helpful: 44,
  },
  {
    id: 'r2-3',
    productId: 2,
    author: '임동현',
    avatar: '임',
    rating: 4,
    date: '2025-10-15',
    title: '대용량이라 가격이 합리적이에요',
    body: '5병이면 꽤 많은 양인데 유통기한도 충분하고 보관도 쉬워요. 효과는 꾸준히 먹어야 알 것 같은데, 2개월 정도 먹으니 피부가 윤기있어진 느낌이 나요.',
    verified: true,
    helpful: 22,
  },

  // 스피루리나 200mgX3,600정 1BOX (id: 3)
  {
    id: 'r3-1',
    productId: 3,
    author: '정소영',
    avatar: '정',
    rating: 5,
    date: '2025-11-18',
    title: '1년치 건강 투자, 정말 만족해요!',
    body: '3,600정이라는 양이 처음엔 부담스러웠는데, 가족 4명이 매일 먹으니까 딱 1년 치더라고요. 단위 가격이 훨씬 경제적이고, 유기농 인증까지 받은 제품이라 믿을 수 있어요.',
    verified: true,
    helpful: 76,
  },
  {
    id: 'r3-2',
    productId: 3,
    author: '한민준',
    avatar: '한',
    rating: 5,
    date: '2025-10-30',
    title: '운동하는 분들께 강력 추천!',
    body: '헬스하면서 단백질 보충용으로 먹고 있어요. 인공 단백질이 아닌 천연 성분이라 속이 편하고, 회복도 빨라진 것 같아요. 대용량이라 한번에 사서 오래 먹을 수 있어서 좋아요.',
    verified: true,
    helpful: 63,
  },
  {
    id: 'r3-3',
    productId: 3,
    author: '배지원',
    avatar: '배',
    rating: 4,
    date: '2025-10-12',
    title: '정제가 조금 크지만 효과는 확실해요',
    body: '정제 크기가 좀 커서 처음엔 먹기 힘들었는데 이젠 적응했어요. 4개월 정도 먹으니 체력이 좋아진 게 확실히 느껴집니다. 가족과 함께 먹을 수 있어서 더 경제적이에요.',
    verified: true,
    helpful: 31,
  },
  {
    id: 'r3-4',
    productId: 3,
    author: '신은지',
    avatar: '신',
    rating: 5,
    date: '2025-09-25',
    title: '믿을 수 있는 브랜드!',
    body: 'HACCP 인증을 받은 시설에서 만들어진다는 게 마음에 들어요. 건강식품은 성분보다 제조 환경이 중요한데, 이 제품은 그 부분에서 확실히 신뢰가 가요. 앞으로도 계속 구매할 제품입니다.',
    verified: true,
    helpful: 49,
  },

  // 스피루리나 캡슐 (id: 5)
  {
    id: 'r5-1',
    productId: 5,
    author: '홍지현',
    avatar: '홍',
    rating: 5,
    date: '2025-11-15',
    title: '스피루리나 냄새 없이 편하게!',
    body: '파우더는 냄새 때문에 힘들었는데 캡슐은 정말 편해요. 하루에 3알씩 먹고 있는데 가방에 쏙 들어가서 외출할 때도 챙겨 먹을 수 있어서 좋아요.',
    verified: true,
    helpful: 38,
  },
  {
    id: 'r5-2',
    productId: 5,
    author: '류성훈',
    avatar: '류',
    rating: 4,
    date: '2025-10-22',
    title: '간편하고 효과도 좋아요',
    body: '캡슐이라 먹기 편하고 냄새도 안 나서 좋아요. 3개월 정도 먹으니 피로감이 줄고 집중력이 향상된 것 같습니다. 재구매 의향 100%예요.',
    verified: true,
    helpful: 25,
  },

  // 스피루리나 스틱 (id: 6)
  {
    id: 'r6-1',
    productId: 6,
    author: '노민서',
    avatar: '노',
    rating: 5,
    date: '2025-11-10',
    title: '출장 다닐 때 너무 편해요',
    body: '스틱 하나씩 들고 다니면서 물에 타서 마셔요. 예전엔 통이 커서 챙기기 힘들었는데 이 제품은 정말 간편해요. 맛도 생각보다 괜찮고 녹는 것도 잘 돼요.',
    verified: true,
    helpful: 33,
  },
  {
    id: 'r6-2',
    productId: 6,
    author: '황도윤',
    avatar: '황',
    rating: 4,
    date: '2025-10-18',
    title: '스무디에 넣으면 최고!',
    body: '아침에 스무디 만들 때 하나씩 뜯어서 넣어요. 색이 짙은 초록색이라 처음엔 놀랐지만 과일과 섞으면 티가 안 나요. 건강 챙기기 정말 좋은 제품입니다.',
    verified: true,
    helpful: 20,
  },

  // 약손콩 두유 분말 (id: 7)
  {
    id: 'r7-1',
    productId: 7,
    author: '조수아',
    avatar: '조',
    rating: 5,
    date: '2025-11-22',
    title: '아이들이 너무 좋아해요!',
    body: '두유 분말인데 맛이 정말 고소하고 달지 않아요. 아이들한테 우유 대신 이걸 줬더니 엄청 잘 마셔요. 인공감미료 없는 자연 단맛이 마음에 들어요. 매달 재구매 중입니다.',
    verified: true,
    helpful: 55,
  },
  {
    id: 'r7-2',
    productId: 7,
    author: '서민재',
    avatar: '서',
    rating: 5,
    date: '2025-11-03',
    title: '두유가 이렇게 맛있을 수가!',
    body: '시판 두유보다 훨씬 고소하고 진한 맛이에요. 따뜻하게 마시면 정말 맛있어요. 단백질도 풍부하고 건강에도 좋아서 아침마다 한 잔씩 챙겨 마십니다.',
    verified: true,
    helpful: 41,
  },
  {
    id: 'r7-3',
    productId: 7,
    author: '문지혜',
    avatar: '문',
    rating: 4,
    date: '2025-10-09',
    title: '다이어트 중에 식사 대용으로 좋아요',
    body: '점심 대신 두유 마시고 있어요. 포만감도 좋고 단백질도 충분해서 다이어트에 안성맞춤이에요. 맛도 좋아서 지속하기 어렵지 않아요.',
    verified: true,
    helpful: 19,
  },

  // 약손콩 선식 (id: 8)
  {
    id: 'r8-1',
    productId: 8,
    author: '김태현',
    avatar: '김',
    rating: 5,
    date: '2025-11-19',
    title: '바쁜 아침을 책임지는 선식!',
    body: '아침 준비할 시간이 없을 때 물에 타서 마시는데 정말 든든해요. 여러 곡물이 들어있어서 영양 균형도 좋고, 하루 종일 에너지가 넘쳐요. 가족 모두 아침마다 먹습니다.',
    verified: true,
    helpful: 48,
  },
  {
    id: 'r8-2',
    productId: 8,
    author: '이수현',
    avatar: '이',
    rating: 5,
    date: '2025-11-01',
    title: '고소하고 맛있어요!',
    body: '선식 하면 맛없다는 편견이 있었는데 이 제품은 달라요. 정말 고소하고 맛있어서 식사 대용이 전혀 힘들지 않아요. 건강 관리에 정말 도움이 되는 것 같습니다.',
    verified: true,
    helpful: 36,
  },

  // 스피루리나 파우더 대용량 (id: 9)
  {
    id: 'r9-1',
    productId: 9,
    author: '박준혁',
    avatar: '박',
    rating: 5,
    date: '2025-11-16',
    title: '파우더 중에 가장 품질 좋아요',
    body: '여러 브랜드 파우더 먹어봤는데 여기가 최고예요. 색이 선명한 초록색이고 입자도 곱게 잘 갈려 있어요. 스무디나 요리에 넣어도 잘 섞이고 맛도 부드러워요.',
    verified: true,
    helpful: 52,
  },
  {
    id: 'r9-2',
    productId: 9,
    author: '최은영',
    avatar: '최',
    rating: 4,
    date: '2025-10-24',
    title: '대용량으로 경제적이에요',
    body: '500g이라 꽤 오래 먹을 수 있어요. 매일 1-2 티스푼씩 먹으면 3-4개월은 충분히 되더라고요. 유통기한도 길어서 걱정 없이 구매할 수 있어요.',
    verified: true,
    helpful: 29,
  },

  // 약손콩 로스팅 (id: 10)
  {
    id: 'r10-1',
    productId: 10,
    author: '임하진',
    avatar: '임',
    rating: 5,
    date: '2025-11-14',
    title: '간식으로 최고에요!',
    body: '고소하게 볶아서 그냥 먹어도 정말 맛있어요. 아이 간식으로 주니까 과자 대신 먹어서 너무 좋아요. 샐러드에 뿌려 먹으면 또 색다른 맛이 나요.',
    verified: true,
    helpful: 37,
  },
  {
    id: 'r10-2',
    productId: 10,
    author: '신수정',
    avatar: '신',
    rating: 4,
    date: '2025-10-20',
    title: '고소한 향이 일품이에요',
    body: '포장 뜯는 순간부터 고소한 향이 넘쳐요. 그냥 먹어도 맛있고, 밥에 올려 먹어도 좋아요. 건강 간식으로 매우 추천합니다.',
    verified: true,
    helpful: 21,
  },

  // 스피루리나 정제 대용량 (id: 11)
  {
    id: 'r11-1',
    productId: 11,
    author: '전민호',
    avatar: '전',
    rating: 5,
    date: '2025-11-17',
    title: '천알씩 먹으면 정말 달라요',
    body: '하루에 10알씩 먹기 시작한 지 4개월이 됐는데 확실히 체력과 면역력이 좋아진 게 느껴져요. 대용량이라 가격도 저렴하고 가성비 최고입니다.',
    verified: true,
    helpful: 45,
  },
  {
    id: 'r11-2',
    productId: 11,
    author: '장혜리',
    avatar: '장',
    rating: 4,
    date: '2025-10-26',
    title: '꾸준히 먹기 좋은 대용량!',
    body: '정제 형태라 먹기 편하고, 1,000정이니까 오랫동안 먹을 수 있어요. 건강 관리에 투자하는 느낌으로 매달 주문하고 있습니다.',
    verified: true,
    helpful: 28,
  },

  // 약손콩 환 선물세트 (id: 12)
  {
    id: 'r12-1',
    productId: 12,
    author: '윤소연',
    avatar: '윤',
    rating: 5,
    date: '2025-11-21',
    title: '선물로 딱! 받으신 분이 감동받으셨어요',
    body: '시부모님께 드렸는데 포장이 너무 고급스럽다고 감동받으셨어요. 3세트라 넉넉하게 드릴 수 있어서 좋았고, 맛도 좋다고 계속 먹고 계세요. 명절 선물로 강력 추천합니다!',
    verified: true,
    helpful: 67,
  },
  {
    id: 'r12-2',
    productId: 12,
    author: '김현석',
    avatar: '김',
    rating: 5,
    date: '2025-11-06',
    title: '어버이날 선물로 완벽해요',
    body: '부모님께 드리려고 구매했는데 박스 자체가 너무 예뻐요. 화려하지 않고 고급스러운 디자인이 어른 선물로 딱이에요. 부모님도 매우 만족하신다고 하십니다.',
    verified: true,
    helpful: 53,
  },
  {
    id: 'r12-3',
    productId: 12,
    author: '박혜지',
    avatar: '박',
    rating: 4,
    date: '2025-10-14',
    title: '품질과 포장 모두 만족!',
    body: '선물세트인 만큼 포장이 정말 꼼꼼하게 되어 있어요. 3개가 들어있어 가성비도 좋고, 받는 분도 기뻐하실 것 같아요. 다음 명절에도 구매할 예정입니다.',
    verified: true,
    helpful: 34,
  },
];

export const getReviewsByProductId = (productId: string | number): Review[] =>
  mockReviews.filter((r) => String(r.productId) === String(productId));

export const getRatingBreakdown = (reviews: Review[]): Record<number, number> => {
  const breakdown: Record<number, number> = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
  reviews.forEach((r) => {
    if (breakdown[r.rating] !== undefined) breakdown[r.rating]++;
  });
  return breakdown;
};
